import _asyncToGenerator from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import multiple from '@/mixins/component-multiple';
import utils from '@/utils';
export default {
  mixins: [multiple],
  // 注意
  // 如果包含 d2-tree 的组件引入了这个 mixin
  // 并且通过 <d2-tree v-bind="$attrs"/> 传递参数
  // 千万不要忘记下面这些参数已经不包含在 $attrs
  props: {
    // 选中或者勾选的值
    value: {
      type: [String, Number, Array],
      default: 0,
      required: false
    },
    // 数据源
    // 可以直接传递数组为树的数据
    // 如果传递函数，该方法需要返回 promise<Array>
    source: {
      type: [Function, Array, String],
      default: function _default() {
        return [];
      },
      required: false
    },
    // 多选的时候 是否混合半选状态
    halfMix: {
      type: Boolean,
      default: false,
      required: false
    },
    // 标记数据源中那个字段代表节点 ID
    // d2-tree 也接收此参数作为 nodeKey 的快捷设置
    keyId: {
      type: String,
      default: 'id',
      required: false
    },
    // 标记数据源中那个字段代表节点标题
    // d2-tree 也接收此参数作为 props.label 的快捷设置
    keyLabel: {
      type: String,
      default: 'label',
      required: false
    },
    // 标记数据源中那个字段代表有子节点
    // d2-tree 也接收此参数作为 props.children 的快捷设置
    keyChildren: {
      type: String,
      default: 'children_list',
      required: false
    }
  },
  data: function data() {
    return {
      // 树数据的扁平化结构 数组形式 为了方便其他计算使用
      flattenedArray: [],
      // 树数据的扁平化结构 对象形式 为了方便其他计算使用
      flattenedObject: {},
      // value 对应的 label 或者 label 数组
      // d2-tree 不使用这个数据
      valueLabel: '',
      valueLabels: []
    };
  },
  methods: {
    /**
     * @description 计算树数据的扁平化结构 => 数组
     * @param {Array} source 原始数据
     */
    refreshFlattenedArray: function refreshFlattenedArray(source) {
      this.flattenedArray = utils.helper.flatTreeToArray({
        data: source,
        keyChildren: this.keyChildren
      });
    },

    /**
     * @description 计算树数据的扁平化结构 => 对象
     * @param {Array} source 原始数据
     */
    refreshFlattenedObject: function refreshFlattenedObject(source) {
      this.flattenedObject = utils.helper.flatTreeToObject({
        data: source,
        keyChildren: this.keyChildren,
        keyId: this.keyId,
        includeChildren: true
      });
    },

    /**
     * @description 计算 label 或者 label 数组
     * @description 这里接收的就是原始的 value，需要做多种情况的判断
     * @param {String|Array|Number} value 需要获取 label 的值
     */
    getLabel: function getLabel(value) {
      if (this.multiple) this.getValueLabels(this.tryParseMultipleString(value));else this.getValueLabel(value);
    },

    /**
     * @description 计算 label
     * @description d2-tree 不使用这个方法
     * @param {String|Number} value 需要获取 label 的值
     */
    getValueLabel: function getValueLabel(value) {
      this.valueLabel = this._.get(this.flattenedObject, [value, this.keyLabel].join('.'), '');
    },

    /**
     * @description 计算 label 数组
     * @description d2-tree 不使用这个方法
     * @param {Array} value 需要获取 label 的值
     */
    getValueLabels: function getValueLabels(value) {
      this.valueLabels = value.map(this.getValueLabel);
    },

    /**
     * @description 根据 source 字段获得真实的数据值
     */
    getDataFromSource: function getDataFromSource(source) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var result;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                result = [];

                if (!_this._.isArray(source)) {
                  _context.next = 5;
                  break;
                }

                result = source;
                _context.next = 27;
                break;

              case 5:
                if (!(_this._.isString(source) && _this._.isFunction(_this.$api[source]))) {
                  _context.next = 17;
                  break;
                }

                _context.prev = 6;
                _context.next = 9;
                return _this.$api[source]();

              case 9:
                result = _context.sent;
                _context.next = 15;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](6);
                result = [];

              case 15:
                _context.next = 27;
                break;

              case 17:
                if (!_this._.isFunction(source)) {
                  _context.next = 27;
                  break;
                }

                _context.prev = 18;
                _context.next = 21;
                return source();

              case 21:
                result = _context.sent;
                _context.next = 27;
                break;

              case 24:
                _context.prev = 24;
                _context.t1 = _context["catch"](18);
                result = [];

              case 27:
                return _context.abrupt("return", result);

              case 28:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[6, 12], [18, 24]]);
      }))();
    }
  }
};